export default "__VITE_ASSET__Dz5Blma1__"